import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';

import Link from '../../components/common/Link';

import * as OrganizationsActionCreators from '../../redux/organizations';
const format = v => (v !== undefined && v !== null ? v.toLocaleString() : '');
const CancelButton = styled.div`
  display: inline;
  margin-right: 30px;
`;

class OrganizationsEditPage extends Component {
  state = {
    customContactLimitField: 0,
    charityField: false,
    proField: false
  };

  async componentDidMount() {
    const {
      actions,
      match: { params }
    } = this.props;
    try {
      const promises = [
        actions.getOrganization(params.id),
        actions.getOrganizationContactCounts(params.id),
        actions.getOrganizationFormTotalRespondent(params.id),
        actions.getOrganizationTotalRevenue(params.id),
        actions.getOrganizationEvents(params.id),
        actions.getOrganizationForms(params.id),
        actions.getEmailTemplates(params.id),
        actions.getMemberPlans(params.id)
      ];
      await Promise.all(promises);
    } catch (e) {
      console.error('ERROR: Organisation View', e);
    }
  }
  componentDidUpdate(prevProps) {
    const { organization } = this.props;
    if (organization && !prevProps.organization) {
      this.setState({
        customContactLimitField: organization.custom_contact_limit,
        charityField: !!organization.charity,
        proField: !!organization.pro
      });
    }
  }

  onChangeSwitch = fieldName => (e, checked) =>
    this.setState({ [fieldName]: checked });

  onChangeTextField = fieldName => e =>
    this.setState({ [fieldName]: e.target.value });

  onClickUpdate = async () => {
    const { actions, organization, history } = this.props;
    const { customContactLimitField, charityField, proField } = this.state;
    const updateData = {
      custom_contact_limit: customContactLimitField,
      charity: charityField,
      pro: proField
    };

    await actions.updateOrganization(organization.id, updateData);
    history.push('/organizations');
  };

  render() {
    const {
      organization,
      contactCounts,
      formTotalRespondent,
      totalRevenue,
      events,
      forms,
      templates,
      memberPlans
    } = this.props;
    if (!organization) return null;

    return (
      <div>
        {contactCounts ? (
          <Fragment>
            <h6>Used Contact</h6>
            <p>{format(contactCounts.total)}</p>
          </Fragment>
        ) : null}
        <h6>Payment Ready</h6>
        <p>{organization.payment_ready ? 'Yes' : 'No'}</p>
        <h6>Total Revenue</h6>
        {totalRevenue &&
          totalRevenue.map((v, i) => (
            <p>
              {v.currency} {v.amount.toLocaleString()}
            </p>
          ))}
        {events ? (
          <Fragment>
            <h6>Events</h6>
            <p>{events.length}</p>
          </Fragment>
        ) : null}
        {forms ? (
          <Fragment>
            <h6>Forms</h6>
            <p>{forms.length}</p>
          </Fragment>
        ) : null}
        <h6>Total respondents</h6>
        <p>{format(formTotalRespondent)}</p>
        {templates ? (
          <Fragment>
            <h6>Templates</h6>
            <p>{templates.length}</p>
          </Fragment>
        ) : null}
        {memberPlans ? (
          <Fragment>
            <h6>Membership Plans</h6>
            <p>{memberPlans.length}</p>
          </Fragment>
        ) : null}
        <h2>Edit {organization.name}</h2>
        <div>
          <TextField
            label="Custom contact limit"
            value={this.state.customContactLimitField || ''}
            onChange={this.onChangeTextField('customContactLimitField')}
          />
        </div>
        <div>
          Is charity?
          <Switch
            checked={this.state.charityField}
            onChange={this.onChangeSwitch('charityField')}
          />
        </div>
        <div>
          Can create new events?
          <Switch
            checked={this.state.proField}
            onChange={this.onChangeSwitch('proField')}
          />
        </div>
        <CancelButton>
          <Link to="/organizations">
            <Button variant="outlined" color="primary">
              CANCEL
            </Button>
          </Link>
        </CancelButton>
        <Button
          variant="contained"
          color="primary"
          onClick={this.onClickUpdate}
        >
          Update
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    organization: state.organizations.organization,
    formTotalRespondent: state.organizations.formTotalRespondent,
    contactCounts: state.organizations.contactCounts,
    totalRevenue: state.organizations.totalRevenue,
    events: state.organizations.events,
    forms: state.organizations.forms,
    templates: state.organizations.templates,
    memberPlans: state.organizations.memberPlans
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(OrganizationsActionCreators, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OrganizationsEditPage)
);



// WEBPACK FOOTER //
// ./src/pages/organizations/edit.js